import React, { useRef, useEffect } from 'react';
import styled, { css } from 'styled-components';
import close from '../../assets/icons/close.svg';
import { select } from '../../core/themev2';
import Loader from '../SimpleLoader';

const ModalStyles = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: ${props => (props.openModal ? 'block' : 'none')};
  z-index: 200;
  background: ${props => props.backgroundWrapper};
`;

const ModalContainer = styled.div`
  position: ${props => `${props.position}`};
  min-width: 350px;
  width: ${props => `${props.width}`};
  height: ${props => `${props.height}`};
  background: ${props => props.background};
  left: ${props => `${props.left}`};
  right: ${props => `${props.right}`};
  top: ${props => `${props.top}`};
  bottom: ${props => `${props.bottom}`};
  margin: auto;
  border-radius: ${props => `${props.borderRadius}`};
  overflow-y: ${({ overflow }) => overflow};
  ${({ bottomModal }) =>
    bottomModal &&
    css`
      bottom: 0;
      left: 0;
      right: 0;
      height: auto;
      width: 100%;
      padding-bottom: 0px;
      top: unset;
      border-radius: 8px 8px 0 0;
    `}
`;

const CloseButton = styled.div`
  position: absolute;
  right: ${({ right }) => right};
  top: ${({ top }) => top};
  cursor: pointer;
  z-index: 201;
`;

const ImgClose = styled.div`
  background-image: url(${close});
  width: 24px;
  height: 24px;
`;

const LoaderWrapper = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 200;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

function ModalBase({
  openModal,
  children,
  onClose,
  withoutOutsideClose,
  width = 'fit-content',
  height = 'fit-content',
  backgroundWrapper = 'transparent',
  background = select('white'),
  withoutCloseButton = false,
  isLoading = false,
  overflow = 'unset',
  left = '0',
  right = '0',
  top = '0',
  bottom = '0',
  borderRadius = '8px',
  topPositionClose = '10px',
  rightPositionClose = '10px',
  bottomModal = false,
  position = 'absolute'
}) {
  useEffect(() => {
    document.querySelector('body').style.overflow = 'hidden';
    return () => {
      document.querySelector('body').style.overflow = 'unset';
    };
  }, []);

  const outsideRef = useRef(null);
  const handleOutsideClick = e => {
    if (!outsideRef.current.contains(e.target) && onClose && !withoutOutsideClose) onClose();
  };

  return (
    <ModalStyles openModal={openModal} onClick={handleOutsideClick} backgroundWrapper={backgroundWrapper}>
      <ModalContainer
        ref={outsideRef}
        width={width}
        height={height}
        background={background}
        overflow={overflow}
        left={left}
        right={right}
        top={top}
        bottom={bottom}
        borderRadius={borderRadius}
        bottomModal={bottomModal}
        position={position}
      >
        {isLoading ? (
          <LoaderWrapper>
            <Loader />
          </LoaderWrapper>
        ) : null}
        {!withoutCloseButton && (
          <CloseButton
            data-panel='panel-modal-close'
            type='button'
            className='close'
            onClick={onClose}
            top={topPositionClose}
            right={rightPositionClose}
          >
            <ImgClose />
          </CloseButton>
        )}
        {children}
      </ModalContainer>
    </ModalStyles>
  );
}

export { ModalBase };
